<template>
  <div class="main-container">
    <!-- Author: Siddhartha
      Date: 17/01/2020
    Issue Description: payroll utilities children components -->
    <breadcrumb :list="breadcrumbList" />

    <div class="margintop-32" />
    <tl-header type="h1">Organisation</tl-header>
    <div class="twoColumnGridDashboard marginbottom-5p">
      <div class="utility-container" v-for="(nav, index) in navList" :key="index">
        <div v-if="nav.name !== 'Release Form 16'" style="cursor: pointer;" class="" :class="nav.url ? '': 'disabledMode'" @click="NavigateToUtility(nav.url)">{{nav.name}}</div>
        <div  v-if="nav.name == 'Release Form 16'" style="cursor: pointer;"  @click="enableEmailAlertPopUp()">{{nav.name}}</div>
        <!-- <div class="c-icon"><img src="@/assets/star_normal.svg" /></div> -->
      </div>
    </div>
    <form-sixten-pop-up  v-if="popUpDisplayFlag"
      @closeReportModal="closeReportModal"></form-sixten-pop-up>
     
   <!-- <div class="grid-box"> -->
    <!-- <btn text="leaves_Attendance" type="primary" v-on:click="goToLeavesPage"/> -->
    <!-- <btn text="legacy_salary" type="primary" v-on:click="goToLegacyPage"/> -->
    <!-- <btn text="upload_lop_rlop" type="primary" v-on:click="goToUploadLopRlopPage"/> -->
    <!-- <btn text="add_exit_employee" type="primary" v-on:click="goToAddExitEmployeePage"/> -->
    <!-- <btn text="revise_salary" type="primary" v-on:click="goToReviseSalaryPage"/> -->
    <!-- <btn text="settle_fbp_claims (By Emp Manager -- PL-155)" type="primary" v-on:click="goToSettleFBPClaims"/> -->
    <!-- <btn text="assign_fbp_components" type="primary" v-on:click="goToAssignFBPComponents"/> -->
    <!-- <btn text="Upload fbp claim bills (Employees)" type="primary" v-on:click="goToFBPClaimBillsPage"/> -->
    <!-- <btn text="statutory deduction" type="primary" v-on:click="goToStatutoryDeductionPage"/> -->
    <!-- <btn text="Upload fbp claim bills (Admin)" type="primary" v-on:click="goToFBPClaimBillsPageByAdmin"/> -->
    <!-- <btn text="hold_release_salary" type="primary" v-on:click="goToHoldSalaryPage"/> -->
    <!-- <btn text="statutory_bonus" type="primary" v-on:click="goToStatutoryBonus"/> -->
    <!-- </div> -->

  </div>
</template>


<script>
import formSixtenPopUp from './formSixtenPopUp.vue'
export default {
  props: {},
  components: {
    formSixtenPopUp
  },
  data() {
    return {
      popUpDisplayFlag:false,
      navList:[],
      breadcrumbList:[
              {
                name: "Payroll",
                url: `/dashboard/${this.$route.params.entity_index}/payroll`
              },
              {
                name: "Utilities",
                url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
              }
        ],
    };
  },
  mounted(){
    this.navList= [
        // {
        //   name: "Activate Financial year",
        //   url: ``
        // },
        // {
        //   name: "Allocate salary components ",
        //   url: ``
        // },
        {
          name: "Assign fixed & Non CTC component ",
          // url: ``
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/assignFixedNonCtcComponents`
        },
        //  {
        //   name: "Create salary structure",
        //   url: ``
        // },
        //  {
        //   name: "Delete payroll data",
        //   url: ``
        //   // url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/delete_payroll_data`
        // },
         {
          name: "Exit employee Details",
          // url: ``
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/add_exit_employees`
        },
         {
          name: "Form 16",
          // url: ``
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/form16`
        },
         {
          name: "Hold/Release salary",
          // url: ``
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/hold_release_salary`
        },
        
        //  {
        //   name: "Leaves Attendance",
        //   url: ``
        //   // url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/leaves_attendance`
        // },
        //  {
        //   name: "Legacy salary ",
        //   url: ``
        //   // url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/legacy_salary_data`
        // },
         {
          name: "Lop/Rlop",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/upload_lop_rlop`
        },
        {
          name: "Revise salary",
          // url: ``
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/revise_salary`
        },
        {
          name: "Upload previous Payslips and IT sheets",
          // url: ``
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/uploadPayslipItsheet`
        },
        {
          name: "Release Compensation for ESS",
          // url: ``
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/releaseCompensationESS`
        },
        {
          name: "Upload Form 16 and General Documents",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/uploadForm16AndGeneral`
        },
        {
          name: "Release Form 16",
        },
        {
          name: "Payroll Report Logs",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/payrollReports`
        }
        // {
        //   name: "Statutory Bonus",
        //   url: ``
        //   // url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/statutory_bonus`
        // },
        // {
        //   name: "Statutory Deduction",
        //   url: ``
        //   // url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/statutory_deduction`
        // },
        // {
        //   name: "Manage Roles ",
        //   url: ``
        //   // url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/manageRoles`
        // }
      ];

  },
  methods: {
    closeReportModal() {
      this.popUpDisplayFlag = false;
    },
    NavigateToUtility(url){
      this.$router.push({
        path:url
      });
    },
    goToLeavesPage() {
      //console.log(this.$route)
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/leaves_attendance`
      });
    },
    goToLegacyPage() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/legacy_salary_data`
      });
    },
    goToUploadLopRlopPage() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/upload_lop_rlop`
      });
    },
    goToAddExitEmployeePage() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/add_exit_employees`
      });
    },
    goToAssignFBPComponents(){
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/assign_fbp_components`
      });
    },
    goToSettleFBPClaims() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/settle_fbp_claims`
      });
    },
    goToReviseSalaryPage() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/revise_salary`
      });
    },
    goToFBPClaimBillsPage() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/fbp_claim`
      });
    },
    goToArrearsIncrementPage(){
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/increment_arrears`
      })
    },
    goToFBPClaimBillsPageByAdmin() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/fbpClaims`
      });
    },
    goToHoldSalaryPage(){
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/hold_release_salary`
      })
    },
    goToStatutoryDeductionPage() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/statutory_deduction`
      })
    },
    goToStatutoryBonus(){
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/statutory_bonus`
       })
    },
    goToDeletePayrollPage(){
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/delete_payroll_data`
      })
    },
    goToForm16() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/form16`
      });
    },
    goToAssignFixedNonCTCcomponets(){
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/assignFixedNonCtcComponents`
      });
    },
    async enableEmailAlertPopUp(){
       this.popUpDisplayFlag = true
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss";  //margins
// .grid-box {
//   display: flex;
//   flex-wrap: wrap;
//   .btn {
//     margin-right: 10px;
//     margin-top: 10px;
//   }
// }
.d-heading2 {
  padding-bottom: 7px;
  margin-bottom: 7px;
  border-bottom: solid 2px #eaeaea;
}
li {
  font-size: 14px;
  margin-left: 30px;
  a {
    text-decoration: none;
    color: inherit;
  }
}
.example-item {
  li::before {
    content: "\2022";
    color: #d8d8d8;
    font-size: 26px;
    font-weight: bold;
    display: inline-block;
    width: 24px;
    top: 3px;
    position: relative;
    margin-left: -15px;
  }
}
.grid-box {
  display: grid;
  grid-template-columns: repeat(6,1fr);
  grid-row-gap: 10px;
  // flex-direction: row;
  .btn {
    margin-right: 10px;
  }
}

.utility-container{
  display: flex;
  background-color: #FFFFFF;
  border-radius: 8px;
  border: solid 1px #efefef;
  width: 100%;
  padding: 20px;
  font-weight: bold;
  font-size: medium;
}
</style>
